import React, {FC, useEffect} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {useInView} from 'react-intersection-observer';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';
import {InputComponent, InputComponentType} from 'libs/getDeliveryFormStructure/helpers/helpers';

import {useEmailSuggestion} from './useEmailSuggestion';

import s from './addressFormEmail.scss';

const AddressFieldComponent = InputComponent;

export type PropsType = InputComponentType & {
    target: 'shippingAddress' | 'billingAddress';
};

/**
 * Address form email component with typo suggestion
 */
export const AddressFormEmail: FC<PropsType> = ({target, ...props}) => {
    const {inView, ref} = useInView();
    const {emailSuggestion, reason, resetSuggestion, result} = useEmailSuggestion(target);

    const shouldShowEmailWarning = emailSuggestion === null && result === 'undeliverable';

    const setSuggestedEmail = () => {
        props.onChange?.(emailSuggestion || '');
        sendDesktopAnalyticsEvent(CHECKOUT_DELIVERY_STEP, {
            message: 'Email Correction - Clicked',
        });
    };

    useEffect(() => {
        if (emailSuggestion && inView)
            sendDesktopAnalyticsEvent(CHECKOUT_DELIVERY_STEP, {
                message: 'Email Correction - Visible',
            });
    }, [emailSuggestion, inView]);

    useEffect(() => {
        if (shouldShowEmailWarning && inView) {
            sendDesktopAnalyticsEvent(
                CHECKOUT_DELIVERY_STEP,
                {
                    message: `Email Warning - undeliverable - ${reason}`,
                },
                false,
            );
        }
    }, [shouldShowEmailWarning, reason, inView]);

    return (
        <div className={s.container} ref={ref}>
            <AddressFieldComponent {...props} />

            {emailSuggestion && !shouldShowEmailWarning && (
                <p className={s.suggestion}>
                    Did you mean{' '}
                    <button className={s.suggestionBtn} onClick={setSuggestedEmail} type="button">
                        {emailSuggestion}
                    </button>
                    ?
                </p>
            )}
            {shouldShowEmailWarning && (
                <p className={s.suggestion}>
                    Looks like this email is not valid.
                    <button className={s.suggestionBtn} onClick={resetSuggestion} type="button">
                        Proceed with this email
                    </button>
                </p>
            )}
        </div>
    );
};
